/* eslint-disable react/jsx-no-undef */
import * as React from 'react';
import { Box} from '@mui/material';
import { Helmet } from 'react-helmet';

import BannerGoMidiaBH from '../../../assets/images/banners/banner_site.webp';


import { TopHeader } from './topHeader';
import styled from 'styled-components';

interface INavBar {
  reference: React.RefObject<HTMLDivElement>;
  title?: string | null;
}

const BannerContainer = styled.div`
  width: 100%;
  display: block;

  img.banner-image {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
`;

const BannerImage = styled.img`
  object-fit: cover;
  display: block;
  transition: opacity 0.2s ease;
  opacity: 0;
  &.loaded {
    opacity: 1;
  }
`;

const Header: React.FC<INavBar> = ({ reference, title }) => {

  const handleImageLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.classList.add('loaded');
  };
  
  return (
    <Box sx={{ width: '100%', maxWidth: '100vw', overflow: 'hidden' }}>
      <Helmet>
        <link rel="preload" href={BannerGoMidiaBH} as="image" type="image/webp" />
      </Helmet>
      <TopHeader reference={reference} title={title} />
        <BannerContainer>
            <a
                href="https://api.whatsapp.com/send/?phone=5531982213102&text&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: 'block' }}
            >
                <BannerImage
                    src={BannerGoMidiaBH}
                    alt='Banner GoMidiaBH'
                    className='banner-image'
                    loading="eager"
                    decoding="async"
                    rel="preload"
                    onLoad={handleImageLoad}
                />
            </a>
        </BannerContainer>
    </Box>
  );
};

export default React.memo(Header);